import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';

import { tasksDefaultConfig } from '../tasks/constants';
import { portalDefaultConfigDealer, portalDefaultConfigLender } from '../portal/constants';
import { lenderFeatureFlagsDefaultConfig } from '../lender';
import { tiersDefaultConfig } from '../internalCreditTiers/constants';
import { recertificationDefaultConfig } from '../recertification/constants';
import { voNotificationsDefaultConfig } from '../notificationsManagement/constants';
import { externalDashboardPortalDefaultConfig } from '../externalDashboardPortal/constants';
import { sendApplicationDefaultConfig } from '../sendApplication/constants';

export const getDefaultConfigByType = (
  isDealerUser: boolean
): Partial<Record<PortalConfigurationType, Record<string, any>>> => ({
  [PortalConfigurationType.Tasks]: tasksDefaultConfig,
  [PortalConfigurationType.Portal]: isDealerUser ? portalDefaultConfigDealer : portalDefaultConfigLender,
  [PortalConfigurationType.InternalCreditTiers]: tiersDefaultConfig,
  [PortalConfigurationType.VoNotifications]: voNotificationsDefaultConfig,
  [PortalConfigurationType.Recertification]: recertificationDefaultConfig,
  [PortalConfigurationType.LenderFeatureFlags]: lenderFeatureFlagsDefaultConfig,
  [PortalConfigurationType.SendApplication]: sendApplicationDefaultConfig,
  [PortalConfigurationType.ExternalDashboardAccess]: externalDashboardPortalDefaultConfig,
});
